module.exports = __webpack_public_path__ + "static/media/imposed-face.0591834c.png";